/**
 * Determines if an event is sold out by checking:
 *
 * 1. Event status is sold out (can be skipped)
 * 2. Event capacity is 0
 * 3. All ticket groups or ticket types are sold out
 * 4. Total tickets sold across all groups >= event capacity
 */
export default function checkIsEventSoldOut(page, skipStatusCheck = false) {
  if (!page?.eventDetails) {
    return false;
  }

  // Check explicit sold out status
  if (skipStatusCheck === false && page.eventDetails?.status === 'sold_out') {
    return true;
  }

  // Check if capacity is explicitly set to 0
  if (page.eventDetails?.capacity === 0) {
    return true;
  }

  const hasAtLeastOneTicketType = page.ticketGroups.some(
    ticketGroup => ticketGroup.ticketTypes?.length > 0,
  );

  const entitiesMarkedAsSoldOut = page.ticketGroups.every(
    ticketGroup =>
      ticketGroup.availabilityStatus === 'sold_out' ||
      (hasAtLeastOneTicketType &&
        (ticketGroup.ticketTypes ?? []).every(tt => tt.availabilityStatus === 'sold_out')),
  );

  if (entitiesMarkedAsSoldOut === true) {
    return true;
  }

  // Calculate total tickets sold across all groups and types
  if (page.eventDetails?.capacity > 0) {
    const totalTicketsSold = (page.ticketGroups || []).reduce((eventTotal, ticketGroup) => {
      const groupTotal = (ticketGroup.ticketTypes || [])
        .filter(ticketType => ticketType.status !== 'archived')
        .reduce((groupSum, ticketType) => {
          return groupSum + (ticketType.quantitySold || 0);
        }, 0);

      return eventTotal + groupTotal;
    }, 0);

    // Event is sold out if total sold >= capacity
    return totalTicketsSold >= page.eventDetails.capacity;
  }

  return false;
}
